(function(){
  const els = document.querySelectorAll('.ae-reveal');
  if (!els.length) return;
  const io = new IntersectionObserver((entries)=>{
    entries.forEach(entry=>{ if(entry.isIntersecting){ entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
  }, { threshold: 0.12 });
  els.forEach(el=>io.observe(el));
  document.addEventListener('click', function(e){
    const link = e.target.closest('a[href^="tel:"],a[href*="wa.me"],a[href*="whatsapp"]');
    if(!link) return;
    window.dataLayer = window.dataLayer || [];
    const href = link.getAttribute('href') || '';
    window.dataLayer.push({ event: href.indexOf('tel:') === 0 ? 'click_call' : 'click_whatsapp', link_url: href, source: 'agency_theme_layer' });
  });
})();
